import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig';

export const APP_NAME = 'Tomei Price';
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const SSO_PORTAL_URL = env.SSO_PORTAL_URL;
export const SSO_API_URL = env.SSO_API_URL;
export const APP_BASE_URL = env.APP_BASE_URL;
export const APP_PREFIX_PATH = '';
export const AUTH_PREFIX_PATH = '/auth';
export const TABLE_PREFIX_PATH = '/table';
export const WS_URL = env.WS_URL;
export const WS_API_KEY = env.WS_API_KEY;
export const PRICE_FEED_WS_URL = env.PRICE_FEED_WS_URL;
export const PRICE_FEED_API_KEY = env.PRICE_FEED_API_KEY;

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: 'en',
  navType: NAV_TYPE_SIDE,
  topNavColor: '#3e82f7',
  headerNavColor: '',
  mobileNav: false,
  currentTheme: 'light',
  direction: DIR_LTR,
};
